import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils/Assets';
import { ImageInput } from '@/components/image-input';
import { useState } from 'react';
const CrudAvatarUpload = ({ value, onChange, customClass }) => {
  console.log('asd', value)
  const [avatar, setAvatar] = useState([{
    dataURL: toAbsoluteUrl(`/media/avatars/300-2.png`)
  }]);
  return <ImageInput acceptType={['jpg', 'jpeg', 'png', 'webp']} value={value} onChange={onChange}>
  {({ onImageUpload }) => (
    <div className="image-input size-16" onClick={onImageUpload}>
      <div
        className="btn btn-icon btn-icon-xs btn-light shadow-default absolute z-1 size-5 -top-0.5 -end-0.5 rounded-full"
        onClick={(e) => {
          e.stopPropagation();
          onChange('no_image'); // clear avatar
        }}
      >
        <KeenIcon icon="cross" />
      </div>

      <div
        className="image-input-placeholder rounded-full border-2 border-success image-input-empty:border-gray-300"
        style={{
          backgroundImage: `url(${toAbsoluteUrl(`/media/avatars/blank.png`)})`,
        }}
      >
        {/* {value?.length > 0 && value[0]?.dataURL && <img src={value[0].dataURL} alt="avatar" />} */}
        {Array.isArray(value) && value[0]?.dataURL ? (
            <img src={value[0].dataURL} alt="Company Logo2" />
          ) : typeof value === 'string' ? (
            <img src={value === 'no_image' ? toAbsoluteUrl(`/media/avatars/blank.png`) : value} alt="Company Logo1" />
          ) : null}
        <div className="flex items-center justify-center cursor-pointer h-5 left-0 right-0 bottom-0 bg-dark-clarity absolute">
          <svg /* your svg here */ />
        </div>
      </div>
    </div>
  )}
</ImageInput>
};
export { CrudAvatarUpload };